var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.038 11.758C.632 6.82 0 6.314 0 4.5a4.5 4.5 0 119 0c0 1.814-.632 2.321-4.038 7.258a.563.563 0 01-.924 0zM4.5 6.375a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75z",
    fill: "url(#locationIcon_svg__paint0_linear_6005_11717)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "locationIcon_svg__paint0_linear_6005_11717",
    x1: 9,
    y1: 12,
    x2: 0,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BCEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#98D3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#92E1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DECE0"
  })))));
}

export default SvgLocationIcon;